import React, {useEffect, useState} from "react";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./CheckoutFormStyles.css";
import {Disclosure} from '@headlessui/react'
import {useAuth} from "@workos-inc/authkit-react";
import {createPaymentIntent} from "../virtualtips/requests/AppRequestStripePayment";

const subtotal = '$210.00'
const discount = {code: 'CHEAPSKATE', amount: '$24.00'}
const taxes = '$23.68'
const shipping = '$22.00'
const total = '$341.68'
const products = [
    {
        id: 1,
        name: 'Micro Backpack',
        href: '#',
        price: '$70.00',
        color: 'Moss',
        size: '5L',
        imageSrc: 'https://tailwindui.com/img/ecommerce-images/checkout-page-04-product-01.jpg',
        imageAlt:
            'Moss green canvas compact backpack with double top zipper, zipper front pouch, and matching carry handle and backpack straps.',
    },
    // More products...
]

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
const stripePromise = loadStripe("pk_test_Yd6YqjXZy2VvyEEJx8VBSGAR00TlLBtoq4");

export default function StripeCheckoutFormStyled({venueId, packageId}) {

    const {isLoading, getAccessToken} = useAuth();

    const [clientSecret, setClientSecret] = useState("");
    const [packageVT, setPackageVT] = useState(null);
    const [venueImage, setVenueImage] = React.useState(null);

    const createPaymentIntentSuccess = (responseJson) => {
        if (responseJson && responseJson.clientSecret) {
            setClientSecret(responseJson.clientSecret);
            setPackageVT(responseJson.packagesVTDto);
            setVenueImage(responseJson.imgFileName);
        }
    };

    const createPaymentIntentError = () => {
        alert("Error");
    };

    useEffect(() => {
        if(!isLoading) {
            createPaymentIntent(venueId, packageId, createPaymentIntentSuccess, createPaymentIntentError, getAccessToken);
        }
    }, [isLoading]);

    const appearance = {
        theme: 'stripe'
    };
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <>
            {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-white">
        <body class="h-full">
        ```
      */}
            <main className="">
                <div className="px-4 py-6 px-6">
                    <div className="mx-auto flex max-w-lg">
                        <a href="#">
                            <span className="sr-only">Your Company</span>
                            {venueImage && <img
                                src={venueImage}
                                alt=""
                                className="h-8 w-auto"
                            />}
                        </a>
                    </div>
                </div>

                <h1 className="sr-only">Checkout</h1>

                {/* Mobile order summary */}
                <section aria-labelledby="order-heading" className="bg-gray-50 px-4 py-6 px-6">
                    <Disclosure as="div" className="mx-auto max-w-lg">
                        {({open}) => (
                            <>
                                <div className="flex items-center justify-between">
                                    <h2 id="order-heading" className="text-lg font-medium text-gray-900">
                                        Your Order
                                    </h2>
                                </div>

                                {packageVT && <>
                                    <p className="mt-6 flex items-center justify-between border-t border-gray-200 pt-6 text-sm font-medium text-gray-900">
                                        <span className="text-base">{packageVT.name} ({packageVT.virtualTips} VirtualTipz)</span>
                                        <span className="text-base font-bold">{packageVT.virtualTips} VirtualTipz</span>
                                    </p>
                                    <p className="mt-6 flex items-center justify-between border-t border-gray-200 pt-6 text-sm font-medium text-gray-900">
                                        <span className="text-base font-bold">Total</span>
                                        <span className="text-base font-bold">${packageVT.price}</span>
                                    </p>
                                </>}
                            </>
                        )}
                    </Disclosure>
                </section>

                {/* Checkout form */}
                <section
                    aria-labelledby="payment-heading"
                    className="flex-auto overflow-y-auto px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:px-8 lg:pb-24 lg:pt-8"
                >
                    <div className="mx-auto max-w-lg">
                        <div className="flex items-center justify-center">
                            <div className="StripeCheckoutForm">
                                {clientSecret && (
                                    <Elements options={options} stripe={stripePromise}>
                                        <CheckoutForm/>
                                    </Elements>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}
